import { mutateSkills } from '../../mutations/mutateSkills';
import { organizationAPI } from 'api/phases/endpoints';
import { serialize } from 'object-to-formdata';

export const addSkill = async (name: string) => {
  const formData = serialize({ skill_name: { name } });
  await organizationAPI.addSkill(formData);
  await mutateSkills();
};
